// The page the pane is showing: the last one whose top has passed a third of
// the way down the pane.
export const visiblePage = (pane: HTMLElement) => {
  const probe = pane.getBoundingClientRect().top + pane.clientHeight / 3;
  let page = 1;
  pane
    .querySelectorAll<HTMLElement>("[data-page-number]")
    .forEach((element) => {
      if (element.getBoundingClientRect().top <= probe) {
        page = Number(element.dataset.pageNumber);
      }
    });
  return page;
};
